<template>
  <static-fullscreen-card>
    <template v-slot:title> ({{ data.id }}) {{ data.city }} {{ data.address }} [{{ statusCurrent.text }}] </template>
    <template v-slot:actions>
      <v-menu offset-y>
        <template v-slot:activator="{ on, attrs }">
          <v-btn color="primary" v-bind="attrs" v-on="on" :disabled="loading">
            <v-icon>mdi-debug-step-over</v-icon>
            <btn-title>Статус</btn-title>
          </v-btn>
        </template>
        <v-list>
          <v-list-item v-for="(item, index) in statusItems" :key="index" link>
            <v-list-item-title @click="clickStatus(item)">
              {{ item.action }}
            </v-list-item-title>
          </v-list-item>
        </v-list>
      </v-menu>
      <a-btn-edit v-if="getAccess('agentObjects.edit', id, data)" @click="showEditDialog = true" :disabled="loading" />
    </template>
    <portal to="v-goup" v-if="idShow">
      <v-btn class="mr-3" fab small @click="$emit('close', data)">
        <v-icon>mdi-arrow-left</v-icon>
      </v-btn>
    </portal>
    <portal to="v-main">
      <edit-dialog v-model="showEditDialog" :id="id" :api="url" typeObject="agentObjects"></edit-dialog>
    </portal>
    <v-row>
      <v-col cols="12" sm="6">
        <material-card color="secondary">
          <template v-slot:heading>
            <div class="px-3 py-1">фото объекта</div>
          </template>
          <a-view-images :value="data.photos" :style="{ height: blockHeight + 'px' }" />
        </material-card>
      </v-col>
      <v-col cols="12" sm="6">
        <material-card color="secondary">
          <template v-slot:heading_>
            <div class="px-3 py-1">основная информация</div>
          </template>
          <template v-slot:heading>
            <v-tabs v-model="tab_info" background-color="transparent" slider-color="white">
              <v-tab v-if="tab.show" class="mr-3" v-for="tab in infoTabs" :key="`tab-${tab.name}`">
                {{ tab.title }}
              </v-tab>
            </v-tabs>
          </template>

          <v-tabs-items v-model="tab_info" class="transparent" style="min-height: 200px" touchless>
            <v-tab-item v-if="tab.show" v-for="tab in infoTabs" :key="`tab-${tab.name}`">
              <v-card-text v-if="tab.name == 'auto-task'" style="height: 300px; overflow: auto" class="pa-0">
                <v-simple-table dense class="block_master_stat">
                  <thead>
                    <tr>
                      <td class="text-center font-weight-bold px-0 mx-1" :style="`height: 22px; `">Задача</td>
                    </tr>
                  </thead>
                  <tbody v-if="loaded">
                    <tr v-for="(row, i) in data.tasks" :key="i">
                      <td class="text-left px-0 pl-2" :style="`height: 38px; `">
                        <component :is="'a-view-string'" :model="{ name: 'cc', type: 'number' }" :value="row['name']" />
                      </td>
                    </tr>
                  </tbody>
                </v-simple-table>
              </v-card-text>
              <a-form-view
                v-if="tab.name == 'info'"
                :value="data"
                :model1="[
                  model[0],
                  model[3],
                  model[4],
                  model[5],
                  { name: 'price_m2', title: 'Стоимость кв.м', type: 'string' },
                  model[7],
                  model[8],
                  model[11],
                  model[12],
                ]"
                :model="modelRight"
                :config="{ dense: true }"
                class="block_master"
              />
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
      <v-col cols="12">
        <material-card color="third">
          <template v-slot:heading>
            <v-tabs v-model="tab" background-color="transparent" slider-color="white">
              <v-tab v-for="(tab, i) in tabs" :key="i" class="mr-3">{{ tab.title }}</v-tab>
            </v-tabs>
          </template>
          <v-tabs-items v-model="tab" class="transparent" style="min-height: 200px" touchless>
            <v-tab-item>
              <v-card-text style="height: 300px; overflow: auto">
                <a-view-files :value="data.docs" />
              </v-card-text>
            </v-tab-item>
          </v-tabs-items>
        </material-card>
      </v-col>
    </v-row>
    <div v-if="loading" class="loading-block">
      <div class="loader"></div>
    </div>
    <confirm-dialog ref="confirmDialog"></confirm-dialog>
  </static-fullscreen-card>
</template>

<script>
import { statusChange, autoHeightBlock, getAccess, genModel, modelOptions } from "../../components/mixings";
export default {
  mixins: [statusChange, autoHeightBlock, getAccess, genModel, modelOptions],
  components: {
    editDialog: () => import("./../dialogs/objectsAgentDialog"),
  },
  props: {
    idShow: Number,
  },
  data() {
    return {
      id: 0,
      blockHeight: 250,
      showEditDialog: false,
      loading: false,
      title: "",
      data: {},
      m: this.$store.getters["config/get"].models.objects,
      url: "/mechti/agent_objects",
      tab: 0,
      tabs: [{ title: "Документация" }],
    };
  },
  created() {
    this.$root.title = this.config.title;
    this.id = this.idShow || Number(this.$route.params.id);
    this.fitchData();
  },
  computed: {
    infoTabs() {
      let tabs = [
        { name: "auto-task", title: "задачи", show: this.data?.tasks?.length },
        { name: "info", title: "Информация", show: true },
      ];
      return tabs;
    },
    statuses() {
      let res = [];

      res = this.getOptions({ options: "status_object,status_site" });
      return res;
    },
    statusCurrent() {
      let idx = this.statuses.findIndex((el) => {
        return el.value == this.data.status;
      });
      if (idx == -1) return {};
      return JSON.parse(JSON.stringify(this.statuses[idx]));
    },
    statusItems() {
      let items = [];
      let res = [];
      let status = {};
      let type;
      type = "status";
      status = this.getStatus(type);
      if (status?.["next"]) {
        res = [
          ...res,
          ...this.statuses.filter((s) => {
            return status.next.includes(s.value) && s.field == type;
          }),
        ];
      }
      type = "status_site";
      status = this.getStatus(type);
      if (status?.["next"]) {
        res = [
          ...res,
          ...this.statuses.filter((s) => {
            return status.next.includes(s.value) && s.field == type;
          }),
        ];
      }

      items = JSON.parse(JSON.stringify(res));

      return items;
    },
    modelRight() {
      let model = this.calcModel("config.objects.viewForm2");
      return model;
    },
    config() {
      return this.m?.config?.agentObjects || {};
    },
    model() {
      //let config = JSON.parse(JSON.stringify(this.m?.config?.considers || {}));
      let model = this.calcModelConfig(this.config);
      return model;
    },
  },
  watch: {
    showEditDialog() {
      if (!this.showEditDialog) {
        this.fitchData();
      }
    },
  },
  methods: {
    async fitchData() {
      const d = await this.$axios.get(this.url + "/" + this.id);
      if (d.data && d.data.data) {
        this.data = d.data.data;
        this.data.price_m2 = "";
        if (this.data.ap_area && this.data.ap_price_buy) {
          this.data.price_m2 = (this.data.ap_price_buy / this.data.ap_area).toFixed(2);
        }
      }
    },
  },
};
</script>
